import { render, staticRenderFns } from "./layout-distribute.vue?vue&type=template&id=3c51e0b0&scoped=true&"
import script from "./layout-distribute.vue?vue&type=script&lang=js&"
export * from "./layout-distribute.vue?vue&type=script&lang=js&"
import style0 from "./layout-distribute.vue?vue&type=style&index=0&id=3c51e0b0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c51e0b0",
  null
  
)

export default component.exports